export default "__VITE_ASSET__CPwlyP7Q__"